module.exports = __webpack_public_path__ + "img/4.a14c1c9e.png";